import { useEffect, useState } from "react";
import AbsenListBulanan from "../components/AbsenListBulanan";
import { useAbsensi } from "../../../Context/AbsensiContext";

const AbsenBulananContain = () => {
  const absensiAPI = useAbsensi();

  const [monthFilter, setMonthFilter] = useState(
    `${new Date().getFullYear()}-${(new Date().getMonth() + 1)
      .toString()
      .padStart(2, "0")}`
  );

  const [data, setData] = useState([]);
  const [pending, setPending] = useState(false);

  let isMounted = true;
  useEffect(() => {
    const fetchData = async () => {
      refreshRekapAbsen();
    };

    if (isMounted) fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    refreshRekapAbsen();
  }, [monthFilter]);

  const refreshRekapAbsen = async () => {
    setPending(true);
    absensiAPI.getRekapHarianAbsensiByMonth(monthFilter)
      .then((res) => {
        setData(res.data);
      })
      .finally(() => {
        setPending(false);
      });
  };

  const updateMonthFilter = (newYear) => setMonthFilter(newYear);

  return (
    <AbsenListBulanan
      data={data}
      updateMonthFilter={updateMonthFilter}
      pending={pending}
      monthFilter={monthFilter}
    />
  );
};

export default AbsenBulananContain;
